import React, { useEffect, useMemo, useRef, useState } from 'react';
import useGalaxyGateEngine from './hooks/useGalaxyGateEngine';
import GalaxyGateMinimal from './GalaxyGateMinimal';
import GalaxyGateMedium from './GalaxyGateMedium';
import GalaxyGateCosmic from './GalaxyGateCosmic';

const MODES = ['minimal', 'medium', 'cosmic', 'auto'];

export default function GalaxyGateWidget({ mode = 'auto' }) {
  const containerRef = useRef(null);
  const [resolvedMode, setResolvedMode] = useState('minimal');
  const engine = useGalaxyGateEngine();

  const pickMode = (width) => {
    if (mode !== 'auto' && MODES.includes(mode)) return mode;
    if (width < 200) return 'minimal';
    if (width < 500) return 'medium';
    return 'cosmic';
  };

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return undefined;

    const update = () => {
      const rectWidth = el.getBoundingClientRect().width || 0;
      const parentWidth =
        el.parentElement?.getBoundingClientRect().width || 0;
      const vw = typeof window !== 'undefined' ? window.innerWidth : 0;
      const effectiveWidth = Math.max(rectWidth, parentWidth, vw);
      setResolvedMode(pickMode(effectiveWidth));
    };

    update();

    let ro;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(update);
      ro.observe(el);
    }
    window.addEventListener('resize', update);

    return () => {
      window.removeEventListener('resize', update);
      if (ro) ro.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode]);

  const child = useMemo(() => {
    const props = { ...engine };
    if (resolvedMode === 'minimal') return <GalaxyGateMinimal {...props} />;
    if (resolvedMode === 'medium') return <GalaxyGateMedium {...props} />;
    return <GalaxyGateCosmic {...props} />;
  }, [resolvedMode, engine]);

  return (
    <div ref={containerRef} style={{ width: '100%', minHeight: 40 }}>
      {child}
    </div>
  );
}
